import React from 'react';
import _ from 'lodash';
import SchedulePublicationContent from './SchedulePublicationContent';
import VersionCommentContent from '../../../components/Prompt/Content/VersionCommentContent';
import GlobalRejectCommentContent from 'components/Prompt/Content/GlobalApprovalRejectComment';
import GlobalReviewCommentContent from 'components/Prompt/Content/GlobalReviewComment';

const steps = [
  {
    label: 'ppsi.approvalScheduledPublicationLabel',
    Content: SchedulePublicationContent,
    visible: ppsi => {
      const { targetPublishDate } = ppsi;
      return !!targetPublishDate;
    },
    validate: () => true
  },
  {
    label: 'ppsi.approvalRejectCommentLabel',
    Content: GlobalRejectCommentContent,

    visible: ppsi => {
      return ppsi.status === 'GLOBAL REVIEW';
    },
    validate: ({ state, setState }) => {
      let rejectCommentHasError = false;
      if (!_.get(state, `globalRejectComment`)) {
        rejectCommentHasError = true;
      }
      setState({ rejectCommentHasError });
      return !rejectCommentHasError;
    }
  },
  {
    label: 'ppsi.approvalReviewCommentLabel',
    Content: GlobalReviewCommentContent,

    visible: ppsi => {
      return (
        (ppsi.status === 'DRAFT' && ppsi.parentPpsiId !== null) ||
        (ppsi.status === 'GLOBAL REJECTED' && ppsi.parentPpsiId !== null)
      );
    },
    validate: ({ state, setState }) => {
      let reviewCommentHasError = false;
      if (!_.get(state, `globalReviewComment`)) {
        reviewCommentHasError = true;
      }
      setState({ reviewCommentHasError });
      return !reviewCommentHasError;
    }
  },
  {
    label: 'ppsi.approvalVersionCommentLabel',
    Content: VersionCommentContent,

    visible: ppsi => {
      return (
        (ppsi.version > 1 &&
          ppsi.status !== 'GLOBAL APPROVED' &&
          ppsi.status !== 'GLOBAL REVIEW') ||
        (ppsi.version > 1 &&
          ppsi.status === 'DRAFT' &&
          ppsi.parentPpsiId !== null) ||
        (ppsi.version > 1 &&
          ppsi.status === 'GLOBAL REJECTED' &&
          ppsi.parentPpsiId !== null)
      );
    },
    validate: ({ state, setState, languages }) => {
      let versionCommentHasError = false;
      if (state.isUpdate) {
        languages.forEach(({ code }) => {
          if (!_.get(state, `versionComment.${code}`)) {
            versionCommentHasError = true;
          }
        });
      }
      setState({ versionCommentHasError });
      return !versionCommentHasError;
    }
  }
];

const getApprovalSteps = ppsi => {
  return steps.filter(step => step.visible(ppsi));
};

export default getApprovalSteps;
